import { FILE_MAX_SIZE_ERROR, FILE_TYPE_ERROR, MAX_FILE_SIZE_BYTES, SUPPORTED_FILE_MIME } from '@shared/model/file-upload';
export const validateFile = (file) => {
    var _a;
    if (((_a = file === null || file === void 0 ? void 0 : file.size) !== null && _a !== void 0 ? _a : 0) > MAX_FILE_SIZE_BYTES) {
        return FILE_MAX_SIZE_ERROR;
    }
    if (file && !SUPPORTED_FILE_MIME.includes(file.type)) {
        return FILE_TYPE_ERROR;
    }
    return null;
};
